module.exports = __webpack_public_path__ + "static/media/(V)_MG_5663_-_Cia_Termal_Beachewear_-_Moda_Masculina_Infantil.0c9a5ba9.jpg";